module.exports = __webpack_public_path__ + "img/agrilims-logo.d51017cb.svg";